/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileExcel32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill="#217346"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill={vars.white}
                d="M17.5 12v.75h3.75a.75.75 0 01.743.648L22 13.5v8.25a.75.75 0 01-.648.743l-.102.007H17.5V24L10 22.687v-9.375L17.5 12zm3.75 1.5H17.5v.75h.75V15h-.75v.75h.75v.75h-.75v.75h.75V18h-.75v.75h.75v.75h-.75v.75h.75V21h-.75v.75h3.75V13.5zm-.75 6.75V21H19v-.75h1.5zM15.955 15l-1.305.075-.787 1.762-.053.158-.06.135v-.045l-.037-.113-.038-.105-.81-1.68-1.26.075L12.947 18 11.5 20.73l1.223.067.824-1.792.038-.127v.112l.855 1.913L16 21l-1.598-3 1.553-3zm4.545 3.75v.75H19v-.75h1.5zm0-1.5V18H19v-.75h1.5zm0-1.5v.75H19v-.75h1.5zm0-1.5V15H19v-.75h1.5z"
            />
        </g>
    </AccessibleSVG>
);

export default FileExcel32;
